import React, { useState, useContext } from "react";
import SkadiModal from "../../../../components/modal/skadiModal";
import SkadiSnackbar from "../../../../components/snackbar";
import firebase from "firebase";
import moment from "moment";
import { StateContext } from "../index";
import { addBatchLog } from "../helpers";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    width: 350,
    "& div": {
      width: "100%",
    },
    "& .MuiInputAdornment-positionEnd": {
      justifyContent: "flex-end",
    },
  },
  formControl: {
    margin: theme.spacing(2, 0, 1, 0),
    minWidth: 120,
  },
  checkers: {
    margin: theme.spacing(1, 0, 2, 0),
    minWidth: 120,
    height: 48,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  buttons: {
    marginTop: "auto",
    paddingTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
  },
  applybutton: {
    color: "white",
  },
}));

const AddForm = ({ klus, handleClose, sjaars }) => {
  const classes = useStyles();
  const context = useContext(StateContext);

  sjaars = sjaars
    .filter((a) => {
      return a.autoAssign === true;
    })
    .sort((a, b) => {
      return a.kookklussen - b.kookklussen;
    });

  const [error, setError] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [r, setKlus] = useState(klus);
  const [value, setValue] = React.useState("vroeg");

  const handleTime = (event) => {
    setValue(event.target.value);
  };

  const handleChange = (e, n) => setKlus({ ...r, [n]: e.target.value });

  const handleSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenError(false);
  };

  const saveSjaars = () => {
    if (!r.datum || !value || !r.naam || !r.aantal) {
      setOpenError(true);
    } else {
      const vanpick = value === "vroeg" ? "16:00" : "19:00";
      const totpick = value === "vroeg" ? "19:00" : "22:00";
      const date = r.datum.startOf("day");
      const van = moment(date.format("LL") + " " + vanpick, "LLL").toDate();
      const tot = moment(date.format("LL") + " " + totpick, "LLL").toDate();

      const db = firebase.firestore();
      const ref = db.collection("kook-eerstejaars" + context.state.year).doc();
      const id = ref.id;
      let batch = db.batch();
      batch.set(ref, {
        naam: r.naam,
        datum: date.toDate(),
        van: van,
        tot: tot,
        aantal: Number(r.aantal),
      });
      let i;
      for (i = 0; i < r.aantal; i++) {
        batch.set(db.collection("kook-indeling" + context.state.year).doc(), {
          klus: id,
          eerstejaars: sjaars[i].id,
          voltooid: false,
          boete: false,
          opmerking: null,
        });
        batch.update(
          db.collection("eerstejaars" + context.state.year).doc(sjaars[i].id),
          {
            kookklussen: firebase.firestore.FieldValue.increment(1),
          }
        );
        addBatchLog(
          batch,
          sjaars[i].id,
          "add",
          "Toegevoegd aan kookklus: " + r.naam,
          true,
          id,
          r.naam,
          context.state.year
        );
      }
      batch.commit().then(() => {
        handleClose();
        context.actions.setKookKlus({ id: id, naam: r.naam });
      });
    }
  };
  return (
    <>
      <SkadiModal
        open={true}
        onClose={handleClose}
        title={"Kooklus toevoegen"}
        onEnter={saveSjaars}
        error={error}
        setError={setError}
      >
        <div className={classes.root}>
          <form className={classes.form}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} lg={12}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDatePicker
                    required
                    clearable
                    margin="normal"
                    id="date-picker"
                    label="Datum"
                    format="DD/MM/YYYY"
                    placeholder="28/10/1926"
                    value={r["datum"]}
                    onChange={(e) => setKlus({ ...r, datum: e })}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
                <FormControl
                  required
                  component="fieldset"
                  className={classes.formControl}
                >
                  <FormLabel component="legend">Tijd</FormLabel>
                  <RadioGroup
                    aria-label="tijd"
                    name="tijd1"
                    value={value}
                    onChange={handleTime}
                  >
                    <FormControlLabel
                      value={"vroeg"}
                      control={<Radio />}
                      label="Vroeg (16:00-19:00)"
                    />
                    <FormControlLabel
                      value={"laat"}
                      control={<Radio />}
                      label="Laat (19:00-22:00)"
                    />
                  </RadioGroup>
                </FormControl>
                <TextField
                  required
                  key={"aantal"}
                  label={"Aantal Klussen"}
                  value={r["aantal"]}
                  onChange={(e) => handleChange(e, "aantal")}
                  margin="normal"
                  type="number"
                />
              </Grid>
            </Grid>
          </form>
          <div className={classes.buttons}>
            <Button color="primary" onClick={handleClose}>
              Annuleren
            </Button>
            <Button
              className={classes.applybutton}
              color="primary"
              variant="contained"
              onClick={saveSjaars}
            >
              Opslaan
            </Button>
          </div>{" "}
        </div>
      </SkadiModal>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={openError}
        autoHideDuration={6000}
        onClose={handleSnack}
      >
        <SkadiSnackbar
          onClose={handleSnack}
          variant="error"
          message={"Vul alle velden in"}
        />
      </Snackbar>
    </>
  );
};

const AddKookKlussenEerstejaars = ({ id, setId, sjaars }) => {
  const open = id != null;
  const newKlus = {
    aantal: 3,
    datum: null,
    naam: "Kookklus",
    tot: null,
    van: null,
  };
  const handleClose = () => {
    if (open) setId(null);
  };
  if (!open || !sjaars) return <></>;
  else
    return <AddForm klus={newKlus} handleClose={handleClose} sjaars={sjaars} />;
};

export default AddKookKlussenEerstejaars;
